import { defineComponent as _defineComponent } from 'vue'
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import MenuPermissionService from "@/services/MenuPermissionIquiryDataService";
import UserInfoDataService from "@/services/UserInfoDataService";
import { store } from "@/store/store";
import ResponseData from "@/types/ResponseData";
import { onMounted, onUpdated, reactive, ref } from "vue";
import { useI18n } from "vue3-i18n";
import AdminNavigation from "../../AdminNavigationContainer.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref(store.getters.showPageTitle);
const radioCheck = ref("");
const isSearch = ref(false);
const inputUserId = ref("");
const selectedArea = ref("");
const areaList = reactive([]);
const selectedStation = ref("");
const oriStationList = reactive([]);
const stationList = reactive([]);
const selectedMainTitle = ref("");
const mainTitleList = reactive([]);
const selectedMenu = ref("");
const oriMenuList = reactive([]);
const menuList = reactive([]);
const selectedDept = ref("");
const departmentList = reactive([]);
const userObj = reactive([]);
const userMenuList = reactive([]);
const userIdError = ref("");
const userFullName = ref("");

const pageCount = ref(1);
const currentPageNo = ref(1);
const userBackBtnText = ref("<< Back");
const userNextBtnText = ref("Next >>");
const allUserObjList = reactive([]);
const userObjList = reactive([]);
const isNoData = ref(false);
const userDetailObj = reactive([]);
const userDetailFullName = ref("");
const userDetailMenuList = reactive([]);

/** 初期表示設定 */
onMounted(async function () {
    isLoading.value = true;
    radioCheck.value = "ByUserId";
    await Promise.all([
        getAreaList(),
        getMenuList(),
        getDepartmentList()
    ]);
});

const getAreaList = () => {
    areaList.splice(0);
    MenuPermissionService.getAreaInfo().then((resArea: ResponseData) => {
        areaList.push(resArea.data);
        selectedArea.value = areaList[0][0].areaCode;
        getStationCodeList();
        isLoading.value = false;
    })
        .catch((e: Error) => {
            console.log(e);
        });
};

const getStationCodeList = () => {
    oriStationList.splice(0);
    oriStationList.value = store.getters.stationListData;
    stationList.splice(0);
    for (let stData of oriStationList.value) {
        if (stData.areaCode == selectedArea.value) {
            stationList.push(stData);
        }
    }
    selectedStation.value = stationList[0].stationCode;
};

const getMenuList = () => {
    oriMenuList.splice(0);
    menuList.splice(0);
    mainTitleList.splice(0);
    var data = {"targetScreen": "MenuPermissionInquiry"}
    MenuPermissionService.getAllMainMenuInfo(data).then((resMenuList: ResponseData) => {
        mainTitleList.push(resMenuList.data.mainTitleList)
        selectedMainTitle.value = mainTitleList[0][0].mainTitleCode;
        oriMenuList.push(resMenuList.data.mainMenuList);
        if (oriMenuList.length != 0) {
            var lstMenuByTitle = oriMenuList[0].filter((obj: { mainTitleCode: { mainTitleCode: any; }; }) => obj.mainTitleCode.mainTitleCode == selectedMainTitle.value)
            menuList.push(lstMenuByTitle);
            selectedMenu.value = menuList[0][0].mainMenuCode;
        }
        isLoading.value = false;
    })
        .catch((e: Error) => {
            console.log(e);
        });
};

const getMenuyByTitle = (event: { target: { value: any; }; }) => {
    menuList.splice(0);
    selectedMainTitle.value = event.target.value;
    if (oriMenuList.length != 0) {
        var lstMenuByTitle = oriMenuList[0].filter((obj: { mainTitleCode: { mainTitleCode: any; }; }) => obj.mainTitleCode.mainTitleCode == selectedMainTitle.value)
        menuList.push(lstMenuByTitle);
        selectedMenu.value = menuList[0][0].mainMenuCode;
    }
}

const getDepartmentList = () => {
    departmentList.splice(0);
    MenuPermissionService.getDepartmentInfo().then((resDeptList: ResponseData) => {
        departmentList.push({ group: '*ALL', managerMail: '', groupMail: '' })
        if (resDeptList.data.length != 0) {
            for (let dept of resDeptList.data) {
                departmentList.push(dept);
            }
        }
        selectedDept.value = departmentList[0].group;
        isLoading.value = false;
    })
        .catch((e: Error) => {
            console.log(e);
        });
};

const rdoCheckChange = (event: { target: { value: any; }; }) => {
    radioCheck.value = event.target.value;
    userIdError.value = "";
    userObj.splice(0);
    userFullName.value = "";
    userMenuList.splice(0);
    allUserObjList.splice(0);
    userObjList.splice(0);
    isNoData.value = false;
    userDetailObj.splice(0);
    userDetailMenuList.splice(0);
    userDetailFullName.value = "";
    isSearch.value = false;
    if (radioCheck.value == "ByUserId") {
        selectedArea.value = areaList[0][0].areaCode;
        getStationCodeList();
        selectedStation.value = stationList[0].stationCode;
        selectedMenu.value = menuList[0][0].mainMenuCode;
        selectedDept.value = departmentList[0].group;
    } else {
        inputUserId.value = "";
    }
};

const areaChange = (event: { target: { value: any; }; }) => {
    selectedArea.value = event.target.value;
    getStationCodeList();
};

const goSearchByUser = () => {
    isSearch.value = true;
    isLoading.value = true;
    userIdError.value = "";
    userObj.splice(0);
    var userId = radioCheck.value == "ByUserId" ? inputUserId.value : userDetailObj[0].userId;
    if (userId.trim() == "") {
        userIdError.value = i18n.t("alt031");
        isLoading.value = false;
        return;
    }
    UserInfoDataService.getUserIDInfo({
        userAuthenticateId: userId,
    })
        .then((resUser: ResponseData) => {
            if (resUser.data.length != 0) {
                userObj.push(resUser.data[0]);
                userMenuList.splice(0);
                UserInfoDataService.getSideMenuList({
                    data: userId,
                })
                    .then((resUserMenu: ResponseData) => {
                        if (radioCheck.value == "ByUserId") {
                            userFullName.value = userObj[0].givenName + " " + userObj[0].familyName;
                            userMenuList.push(resUserMenu.data);
                        } else {
                            userDetailFullName.value = userDetailObj[0].givenName + " " + userDetailObj[0].familyName;
                            userDetailMenuList.push(resUserMenu.data);
                        }
                        isLoading.value = false;
                    })
                    .catch((e: Error) => {
                        console.log(e);
                    });
            } else {
                userIdError.value = i18n.t("alt032");
                isLoading.value = false;
            }
        })
        .catch((e: Error) => {
            console.log(e);
        });
};

const goSearchByMenu = () => {
    isSearch.value = true;
    isLoading.value = true;
    allUserObjList.splice(0);
    userObjList.splice(0);
    isNoData.value = false;
    MenuPermissionService.getUserListByMenu({
        stationCode: selectedStation.value,
        menuCode: selectedMenu.value,
        deptCode: selectedDept.value
    })
        .then((resUserList: ResponseData) => {
            if (resUserList.data.length != 0) {
                pageCount.value = Math.ceil(resUserList.data.length / 10);
                currentPageNo.value = 1;
                allUserObjList.push(resUserList.data);
                var startIdx = 0;
                for (let obj of allUserObjList[0]) {
                    if (startIdx < 10) {
                        userObjList.push(obj);
                        startIdx++;
                    } else {
                        break;
                    }
                }
            } else {
                pageCount.value = 1;
                currentPageNo.value = 1;
                isNoData.value = true;
            }
            isLoading.value = false;
        })
        .catch((e: Error) => {
            console.log(e);
            isLoading.value = false;
        });
};

const changeUserPage = (direction: string) => {
    userObjList.splice(0);
    var startIndex = 0;
    var endIndex = 0;
    if (direction == "Next") {
        startIndex = currentPageNo.value * 10;
        endIndex = (currentPageNo.value * 10) + 10;
        if (endIndex >= allUserObjList[0].length) {
            endIndex = allUserObjList[0].length;
        }
        currentPageNo.value = currentPageNo.value + 1;
    } else {
        startIndex = ((currentPageNo.value - 1) * 10) - 10;
        endIndex = (currentPageNo.value * 10) - 10;
        currentPageNo.value = currentPageNo.value - 1;
    }
    for (var i = startIndex; i < endIndex; i++) {
        userObjList.push(allUserObjList[0][i]);
    }
}

const goDetailSearchByUser = (user: any) => {
    userDetailObj.splice(0);
    userDetailObj.push(user);
    userDetailFullName.value = "";
    userDetailMenuList.splice(0);
    goSearchByUser();
}

const goToApprovalHistory = () => {
    store.dispatch("setShowPage","MenuApprovalHistory");
    store.dispatch("setShowPageTitle","Menu Approval History Inquiry");
}

onUpdated(function () {
    var tableHeight = 0;
    if(userMenuList.length != 0){
        var dataHeight1 = document.getElementById("tbodyByUserMenuResult")?.clientHeight;
        if (dataHeight1 != 0 && dataHeight1 != undefined) {
            var mydivh1 = document.getElementById("divByUserMenuResult")?.clientHeight;
            tableHeight = (mydivh1 * 96) / 100 - 200;
            if (dataHeight1 > tableHeight) {
                document.getElementById("divByUserMenuResult").style.width = "917px";
            } else {
                document.getElementById("divByUserMenuResult").style.width = "900px";
            }
        }
    }else if(userDetailMenuList.length != 0){
        var dataHeight2 = document.getElementById("tbodyDetailMenu")?.clientHeight;
        if (dataHeight2 != 0 && dataHeight2 != undefined) {
            var mydivh2 = document.getElementById("tbodyDetailDiv")?.clientHeight;
            tableHeight = (mydivh2 * 96) / 100 - 200;
            if (dataHeight2 > tableHeight) {
                document.getElementById("tbodyDetailDiv").style.width = "917px";
            } else {
                document.getElementById("tbodyDetailDiv").style.width = "900px";
            }
        }
    }
});


const __returned__ = { isLoading, alertMessage, alertState, i18n, title, radioCheck, isSearch, inputUserId, selectedArea, areaList, selectedStation, oriStationList, stationList, selectedMainTitle, mainTitleList, selectedMenu, oriMenuList, menuList, selectedDept, departmentList, userObj, userMenuList, userIdError, userFullName, pageCount, currentPageNo, userBackBtnText, userNextBtnText, allUserObjList, userObjList, isNoData, userDetailObj, userDetailFullName, userDetailMenuList, getAreaList, getStationCodeList, getMenuList, getMenuyByTitle, getDepartmentList, rdoCheckChange, areaChange, goSearchByUser, goSearchByMenu, changeUserPage, goDetailSearchByUser, goToApprovalHistory, Loading, Alert, AdminNavigation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})